import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();
export const createVehicule = async (data) => {
  console.log('data veh =>', data)
  try {
      const response = await api.create(`/vehicles/add`, data);
      return response;
  } catch (error) {
      console.error("❌ Erreur API :", error.response?.data || error.message);
      throw error;
  }
};


  export const getVehicules = async () => {
      try {
        const response = await api.get(`/vehicles/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateVehicule = async ( id, data) => {
      try {
        const response = await axios.put(`/vehicles/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteVehicule = async (id) => {
    try {
        const response = await api.delete(`/vehicles/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
 export const getVehicleById = async (id) => {
      try {
        const response = await api.get(`/vehicles/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  
  export const affectVehicle = async (driverId, vehicleId) => {
    try {
        const response = await api.put(`/vehicles/affect/user/${driverId}/vehicle/${vehicleId}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
